module.exports = __webpack_public_path__ + "img/label-type1.c14051f5.svg";